import React from 'react';
import { Mail } from 'lucide-react';
import Logo from '../Logo';

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container-x">
        <div className="footer-grid">
          <div className="footer-about">
            <a className="brand" href="#main" aria-label="JustICP home">
              <Logo />
            </a>
            <p>JustICP is an AI-powered lead generation partner helping B2B agencies, SaaS companies, and consultants build predictable, calendar-filling pipelines, without the burnout of a full sales team.</p>
            <div className="footer-meta">
              <a href="mailto:nipun@justicp.com"><Mail size={14}/> nipun@justicp.com</a>
              <a href="mailto:harissh@justicp.com"><Mail size={14}/> harissh@justicp.com</a>
            </div>
          </div>
          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">AI Lead Generation</a></li>
              <li><a href="#services">Email Outreach</a></li>
              <li><a href="#services">LinkedIn Outreach</a></li>
              <li><a href="#services">Appointment Setting</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              <li><a href="#main">About</a></li>
              <li><a href="#case-studies">Case Studies</a></li>
              <li><a href="#main">Blog</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="https://cal.com/one-up-n0typj/discovery" target="_blank" rel="noopener noreferrer">Book a Call</a></li>
            </ul>
          </div>
          <div className="footer-col">
            <h4>Legal</h4>
            <ul>
              <li><a href="#main">Privacy Policy</a></li>
              <li><a href="#main">Terms of Service</a></li>
              <li><a href="#main">Cookies</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <div>© 2026 JustICP. All rights reserved.</div>
          <div>Built with care · Results guaranteed.</div>
        </div>
      </div>
    </footer>
  );
}
